import React, { Component } from 'react';

class TextInput extends Component {


  componentDidMount() {
  }

  render() {

    return this.props.edit ? 
      (
        <input type="text" value={this.props.value} onChange={(e) => this.props.changeValue(this.props.name, e.target.value)} />
      ) : 
      (
        <div>{this.props.value}</div>
      );
  }

}

export default TextInput;



// WEBPACK FOOTER //
// ./src/elements/TextInput.js